export default [
    //海南文博
    {
        path: '/introductoryArticle',
        name: 'introductoryArticle',
        component: () => import('../views/introductoryArticles/introductoryArticle.vue'),
        meta: {
            hasTabbar: true,
        }
    },
    //海南文博详情
    {
        path: '/listdetailed',
        name: 'listdetailed',
        component: () => import('../views/introductoryArticles/listdetailed.vue'),
        meta: {
            hasTabbar: true,
        }
    },
];